import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";
import Dropzone from "react-dropzone";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";

import {
	GridCell,
	Button,
	logProps,
	createAsset,
	plog,
	ContainedImage,
} from "src/components/common";

// --------------------------------------------------

const ImageViewerWrapper = styled.div`
	width: 100%;
	max-width: 400px;
	margin-bottom: 1em;
	background-color: rgba(0,0,0,0.1);
`;

const ImageViewer = ContainedImage;

const PreviewWrapper = styled.div`
	width: 100%;
	padding-top: 100%;
	position: relative;	
`;

const PreviewInner = styled.div`
	${m.contained()}
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const PreviewText = styled.div`
	font-size: 1.2em;
	margin-top: 0.5em;
`;

const PreviewImage = styled.div`
	width: 40%;
	padding-top: 40%;
	background-image: url(${R.prop("src")});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center bottom;
`;

// --------------------------------------------------

//states: "", UPLOADING, ERROR,

const dropzoneStyle = {
	display: "inline-block",
}

const enhance = compose(
	connect(R.identity),
	withState("status", "setStatus", ""),
	withState("preview", "setPreview", ""),
	withState("contentImage", "setContentImage", ""),
	withPropsOnChange(
		[ "content", ],
		({ content, setContentImage, space, }) => {
			console.log("content changed");
			const assetId = R.path([ "sys", "id", ])(content);
			if (assetId) {
				space.getAsset(assetId)
				.then(plog("get asset"))
				.then(R.path([ "fields", "file", consts.lang, "url", ]))
				.then(url => {
					console.log("asset url", url);
					if (url) {
						setContentImage(url);
					}
				})
			}

			return {};
		}
	),
	withHandlers({
		onDrop: ({ space, setContent, setPreview, setStatus, setContentImage, }) => (files) => {
			const file = files[0];
			console.log("file", file);

			if (file) {
				setPreview(file.preview);
				setStatus("UPLOADING");

				createAsset({
					space,
					file,
					onUploaded: () => setStatus("PROCESSING"),
					onPublished: asset => {
						setContentImage("");
						setPreview("");
						setContent({
							sys: {
								type: "Link",
								linkType: "Asset",
								"id": asset.sys.id,
							},
						});
						setStatus("");
					},
				});
			}
			else {
				setStatus("ERROR");
			}
		},
	}),
	logProps("ImageUpload"),
);

const Comp = ({
	status,
	onDrop,
	preview,
	content,
	contentImage,
}) => {
	if (!status) {
		return (
			<div>
				{
					content
					? (
						<ImageViewerWrapper>
							<ImageViewer src = { contentImage }/>
						</ImageViewerWrapper>
					)
					: null
				}				
				<Dropzone
					style = { dropzoneStyle }
					accept = "image/*"
					onDrop = { onDrop }

				>
					<Button text = "Upload new image"/>
				</Dropzone>
			</div>
		);
	}
	else if (status === "UPLOADING" || status === "PROCESSING") {
		return (
			<ImageViewerWrapper>
				<PreviewWrapper>
					<PreviewInner>
						<PreviewImage src = { preview }/>
						<PreviewText>
							{
								status === "UPLOADING"
								? "Uploading..."
								: "Processing..."	
							}
						</PreviewText>
					</PreviewInner>
				</PreviewWrapper>
			</ImageViewerWrapper>
		);
	}

	return null;


}




export const ImageUpload = enhance(Comp);


// WEBPACK FOOTER //
// ./src/components/Editor/Pages/Field/image.js